import { Fragment } from 'react';

import { generateClassName } from '@klv/shared/utils/functions';

import * as s from './styles/breadcrumbs.module.css';

import type { IBreadcrumbs } from './types';

export const Breadcrumbs = ({
  background = 'transparent',
  breadcrumbs = [],
  className = '',
  colorVariant = 'light',
}: IBreadcrumbs) => {

  if (!breadcrumbs.length) return null;

  const lastIndex = (breadcrumbs.length - 1);

  return (
    <div className={generateClassName([className, s.breadcrumbsComponent, s[background]])}>
      <nav className={generateClassName(['grid', s.container])}>
        <div className={generateClassName([s.breadcrumbs, s[colorVariant]])}>
          {breadcrumbs.map(({ link, text }, index) => (
            <Fragment key={link + text}>
              {index !== lastIndex ?
                <Fragment key={`${link} ${text}`}>
                  <a className={s.breadcrumb} href={link}>
                    {text}
                  </a>
                  <span className={s.spacer}>/</span>
                </Fragment>
                :
                <div className={s.lastBreadcrumb}>
                  {text}
                </div>
              }
            </Fragment>
          ))}
        </div>
      </nav>
    </div>
  );
};
